var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',_vm._b({},'gl-empty-state',{ ..._vm.$options.emptyStatePropsMap[_vm.errorCode], svgPath: _vm.illustrations[_vm.errorCode] },false))
}
var staticRenderFns = []

export { render, staticRenderFns }